import { marked } from "marked";
import DOMPurify from "dompurify";

marked.use({
  breaks: true,
  gfm: true,
  renderer: {
    link({ href, title, tokens }) {
      const text = this.parser.parseInline(tokens);
      const titleAttr = title ? ` title="${title}"` : "";
      return `<a href="${href}"${titleAttr} target="_blank" rel="noopener noreferrer">${text}</a>`;
    },
  },
});

// OpenAI leaks two citation formats into output_text:
//  1. Legacy fullwidth-bracket annotations like 【5:0,4†filename.md】
//  2. ChatGPT-style tokens wrapped in Private Use Area delimiters
//     (U+E200 … U+E201), e.g. an invisible-boxed `filecite turn0file3`.
const PUA_OPEN = String.fromCharCode(0xe200);
const PUA_CLOSE = String.fromCharCode(0xe201);
const PUA_RANGE = `${String.fromCharCode(0xe200)}-${String.fromCharCode(0xe206)}`;
const PUA_CITATION_RE = new RegExp(`${PUA_OPEN}[\\s\\S]*?${PUA_CLOSE}`, "g");
const FW_CITATION_RE = /【[^】]*】/g;
const BARE_CITATION_RE = /(?:file)?cite\s*turn\d+\w+/gi;
const STRAY_PUA_RE = new RegExp(`[${PUA_RANGE}]`, "g");

/** Strip OpenAI file_search citation artifacts before rendering. */
function stripCitations(text: string): string {
  return text
    .replace(PUA_CITATION_RE, "")
    .replace(FW_CITATION_RE, "")
    .replace(BARE_CITATION_RE, "")
    .replace(STRAY_PUA_RE, "");
}

export function renderMarkdown(text: string): string {
  const cleaned = stripCitations(text);
  const raw = marked.parse(cleaned, { async: false }) as string;
  return DOMPurify.sanitize(raw, { ADD_ATTR: ["target"] });
}
